export default __webpack_public_path__ + "static/media/logo-sidebar.a0e5dfdc.png";